'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { cn } from '@/utils/styles/cn'
import { PRIMARY_NAV_LINKS } from '@/features/landing-page/v3/solutions-menu-config'

/**
 * The top-level nav links beside Solutions — a small client island (the rest of the v3 nav stays a
 * server component) so the link of the CURRENT page can carry a subtle active pill. Links still ship
 * in the SSR HTML.
 */
export function NavPrimaryLinks() {
    const pathname = usePathname()
    return (
        <>
            {PRIMARY_NAV_LINKS.map((link) => {
                const isActive = pathname === link.href || pathname.startsWith(`${link.href}/`)
                return (
                    <Link
                        key={link.label}
                        href={link.href}
                        prefetch={false}
                        aria-current={isActive ? 'page' : undefined}
                        className={cn(
                            'lp-nav-ink rounded-[8px] px-3 py-2 text-[16px] font-normal leading-[1.25] tracking-[-0.02em] text-foreground transition-colors hover:bg-black/[0.05]',
                            isActive && 'bg-black/[0.06]'
                        )}
                    >
                        {link.label}
                    </Link>
                )
            })}
        </>
    )
}
